import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container my-25 max-w-[1312px] max-md:my-15',
    title:
      'heading-3xl-desk max-lg:heading-3xl max-sm:heading-2xl mb-10 max-sm:mb-6',
    benefits: 'flex gap-6 max-xl:gap-5 max-lg:flex-col',
    benefitsItem:
      'bg-bg-items-white flex flex-1 items-center gap-5 rounded-full p-3.5 pr-5 lg:pr-8',
    benefitsItemIcon:
      'relative size-18 shrink-0 overflow-hidden rounded-full max-sm:size-15',
    benefitsItemTitle:
      'text-[20px] leading-[140%] font-semibold max-xl:text-[18px]'
  }
});
